import _ from 'lodash';

import { scheduleDays } from '@sophocles/entities/RelaySchedule/relayScheduleUtils';

export function statusTypeSwitch(status, t) {
  switch (status) {
    case 1:
      return t('statusView.detail.typeShort', 'Short');
    case 2:
      return t('statusView.detail.typeLong', 'Long');
    case 3:
      return t('statusView.detail.typeCrc', 'CRC');
    case 4:
      return t('statusView.detail.typeLive', 'Live');
    case 9:
      return t('statusView.detail.typeZone', 'Zone');
    case 10:
      return t('statusView.detail.typeMeter', 'Meter');
    case 13:
      return t('statusView.detail.typeTwoPortDc', 'Two-Port DC');
    case 14:
      return t('statusView.detail.typeVantage', 'Vantage');
    default:
      return t('general.unknown', 'Unknown');
  }
}

export function toHex(value) {
  return value != null ? '0x' + value.toString(16).toUpperCase() : null;
}

export function roundOrNull(value, precision) {
  return value == null ? null : _.round(value, precision);
}

export function tempNa(value, t) {
  return value === null
    ? t('statusView.detail.disabledLower', 'disabled')
    : value <= -40
      ? t('statusView.detail.na', 'n/a')
      : _.round(value, 2);
}

export function scheduleFormatter(schedule, dayOfWeekScheduling, t) {
  if (_.get(schedule, 'enabled', false)) {
    return schedule.always_on
      ? t('sites.alwaysOn', 'Always On')
      : liveScheduleFormatter(schedule, dayOfWeekScheduling, t);
  }
  return t('general.disabled', 'Disabled');
}

function liveScheduleFormatter(schedule, dayOfWeekScheduling, t) {
  const {
    on_type: onType,
    on_time: onTime,
    off_type: offType,
    off_time: offTime,
    on_offset: onOffset,
    off_offset: offOffset,
    days_of_week: daysOfWeek,
  } = schedule;

  let days = dayOfWeekScheduling && daysOfWeek != null ? scheduleDays(daysOfWeek, t) : null;
  if (days == null) {
    days = t('statusView.detail.noValue', 'No Value');
  } else if (days.length === 7) {
    days = t('general.everyDay', 'Every Day');
  } else if (days.length === 0) {
    days = t('statusView.detail.noDays', 'No Days');
  } else {
    days = days.join(', ');
  }

  const onStr =
    t('statusView.detail.onPrefix', 'ON: ') +
    (onType != 'time'
      ? `${onOffset ? onOffset + t('statusView.detail.minutesBeforePad', ' minutes before ') : ''}${onType}`
      : onTime);
  const offStr =
    t('statusView.detail.offPrefix', 'OFF: ') +
    (offType != 'time'
      ? `${offOffset ? offOffset + t('statusView.detail.minutesAfterPad', ' minutes after ') : ''}${offType}`
      : offTime);

  return onStr + ' - ' + offStr + (dayOfWeekScheduling ? ` - ${days}` : '');
}

export function toMappedWattage(arr, t) {
  return arr
    ? arr
        .map(x => roundOrNull(x, 1))
        .map(x => (x === null ? t('statusView.detail.disabledLower', 'disabled') : x + 'W'))
        .join(', ')
    : null;
}

export function toMappedAmps(arr, t) {
  return arr
    ? arr
        .map(x => roundOrNull(x, 2))
        .map(x => (x === null ? t('statusView.detail.disabledLower', 'disabled') : x + 'A'))
        .join(', ')
    : null;
}

export function joinOrNull(arr, t) {
  return arr
    ? arr
        .map(x => roundOrNull(x, 3))
        .map(x => (x === null ? t('statusView.detail.disabledLower', 'disabled') : x))
        .join(', ')
    : null;
}

export function joinMonitor(arr, t) {
  if (arr != null) {
    const active = arr.map((x, index) => (x === false ? null : index + 1)).filter(Boolean);
    return active.length > 0 ? active.join(', ') : t('general.none', 'None');
  }
  return null;
}

export function fixedDecimals(value, precision) {
  return value == null ? null : value.toFixed(precision);
}

export function prettifyParamNames(systemName) {
  const prettyName = systemName ? systemName.replaceAll('_', ' ') : ' ';
  return prettyName
    .toLowerCase()
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
